import { render, staticRenderFns } from "./fontSize-editor.vue?vue&type=template&id=14ad4527&scoped=true"
import script from "./fontSize-editor.vue?vue&type=script&lang=js"
export * from "./fontSize-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ad4527",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14ad4527')) {
      api.createRecord('14ad4527', component.options)
    } else {
      api.reload('14ad4527', component.options)
    }
    module.hot.accept("./fontSize-editor.vue?vue&type=template&id=14ad4527&scoped=true", function () {
      api.rerender('14ad4527', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-static-text/fontSize-editor.vue"
export default component.exports